import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "../src/app/App";
import { SvgCollection } from "app/components/svg";
import * as serviceWorker from "./serviceWorker";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";
import store from "../src/app/modules/core/store";
import { Helmet } from "react-helmet";

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_CONTAINER_ID,
};

TagManager.initialize(tagManagerArgs);
ReactDOM.render(
  <React.StrictMode>
    <Helmet>
      <title>DigiPadala Branch Locator</title>
      <meta
        name="description"
        content="DigiPadala Branch Locator is a tool that can be used by both consumers and Digipay Agents to locate Digipay Enabled stores worldwide."
      />
      <meta
        name="keywords"
        content="digipay.ph/branch-locator/, DigiPadala, Branch, Locator, DigiPadala Branch, DigiPadala Locator, DigiPadala Branch Locator, Digipay Maps, Branch"
      />
      <meta name="robots" content="index,follow" />
      <meta name="og:type" content="map" />
      <meta name="og:url" content="https://www.digipay.ph/branch-locator/" />
      <meta
        name="og:title"
        content="DigiPadala Branch Locator - Locate Digipay Agents Near You!"
      />
      <meta name="og:image" content />
      <meta name="og:image" content />
      <meta
        name="og:description"
        content="DigiPadala Branch Locator - Locate Digipay Agents Near You!"
      />
      <meta name="og:site_name" content="DigiPadala Branch Locator" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@DigiPadalaBranchLocator" />
      <meta
        name="twitter:url"
        content="https://www.digipay.ph/branch-locator/"
      />
      <meta
        name="twitter:title"
        content="DigiPadala Branch Locator - Locate Digipay Agents Near You!"
      />
      <meta
        name="twitter:description"
        content="DigiPadala Branch Locator - Locate Digipay Agents Near You!"
      />
      <meta name="twitter:image" content />
      <meta name="twitter:image:alt" content />
    </Helmet>

    <Provider store={store}>
      {/*This <App/> is the App.js inside the app folder. Not the one on the root path. */}
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
ReactDOM.render(<SvgCollection />, document.getElementById("svg"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister();
